class NotificationSoundHelper {
  constructor() {
    this.audioContext = null;
    this.speechSynthesis = window.speechSynthesis;
    this.audioEnabled = false;
    this.initAudioContext();
    this.setupUserGestureHandler();
  }

  initAudioContext() {
    try {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    } catch (error) {
      console.warn('Web Audio API not supported');
    }
  }

  setupUserGestureHandler() {
    const enableAudio = async () => {
      if (this.audioContext && this.audioContext.state === 'suspended') {
        try {
          await this.audioContext.resume();
          this.audioEnabled = true;
          document.removeEventListener('click', enableAudio);
          document.removeEventListener('keydown', enableAudio);
        } catch (error) {
          console.warn('Failed to resume audio context:', error);
        }
      }
    };
    
    document.addEventListener('click', enableAudio, { once: true });
    document.addEventListener('keydown', enableAudio, { once: true });
  }

  playTingSound() {
    if (!this.audioContext || this.audioContext.state !== 'running') return;

    try {
      const oscillator = this.audioContext.createOscillator();
      const gainNode = this.audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(this.audioContext.destination);

      oscillator.frequency.setValueAtTime(800, this.audioContext.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(400, this.audioContext.currentTime + 0.1);

      gainNode.gain.setValueAtTime(0.3, this.audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.3);

      oscillator.start(this.audioContext.currentTime);
      oscillator.stop(this.audioContext.currentTime + 0.3);
    } catch (error) {
      console.warn('Could not play ting sound:', error);
    }
  }

  speakBooking() {
    if (!this.speechSynthesis) return;

    try {
      const utterance = new SpeechSynthesisUtterance('booking');
      utterance.lang = 'id-ID';
      utterance.rate = 1.0;
      utterance.pitch = 1.0;
      utterance.volume = 0.8;

      this.speechSynthesis.speak(utterance);
    } catch (error) {
      console.warn('Could not speak booking:', error);
    }
  }

  async playBookingNotification() {
    try {
      // Resume audio context if suspended
      if (this.audioContext && this.audioContext.state === 'suspended') {
        await this.audioContext.resume();
        this.audioEnabled = true;
      }

      // Play sound even without user gesture (browsers allow this for notifications)
      this.playTingSound();

      setTimeout(() => {
        this.speakBooking();
      }, 300);
    } catch (error) {
      console.warn('Audio notification failed:', error);
    }
  }
}

const notificationSound = new NotificationSoundHelper();

export default notificationSound;